{
  "key": "4it.symbo.ls",
  "framework": "domql",
  "npmClient": "yarn",
  "useWorkspaces": true
}